<script setup>
import { usePage } from '@inertiajs/vue3';
import { toastError, toastSuccess } from '@js/utils/toast';
import { computed, watch } from 'vue';

const successFlash = computed(() => usePage().props.flash.success);

const errorFlash = computed(() => usePage().props.flash.error);

watch(successFlash, (value) => {
    if (value) {
        toastSuccess(value);
    }
});

watch(errorFlash, (value) => {
    if (value) {
        toastError(value);
    }
});
</script>

<template></template>
